import React, { useState } from "react";
import "./LocatorForm.css";
import MapsImage from "../../assets/MapsImage.jpg";

interface Address {
  heading: string;
  line1: string;
  line2: string;
  line3: string;
  line4: string;
}

const StoreLocatorForm = () => {
  const [formData, setFormData] = useState({
    selectedCountry: "",
    selectedCity: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const countries = ["INDIA", "UAE"];
  const citiesIndia = ["GURUGRAM", "CHANDIGARH", "MUMBAI", "RANCHI"];
  const citiesDubai = ["DUBAI"];

  const addresses: { [key: string]: Address } = {
    GURUGRAM: {
      heading: "DLF THE TWO HORIZON CENTRE",
      line1: "LEVEL 5TH, WEWORK GLOBAL",
      line2: "DLF THE TWO HORIZON CENTRE",
      line3: "DLF PHASE-5, GOLFCOURSE ROAD",
      line4: "SECTOR- 43, GURUGRAM, HARYANA, 122002",
    },
    CHANDIGARH: {
      heading: "SUNNY ENCLAVE",
      line1: "LEVEL GROUND FLOOR 10J",
      line2: "FRIENDS RESIDENCE, KHARAR",
      line3: "SECTOR-123, SUNNY ENCLAVE",
      line4: "MOHALI, PUNJAB 140301",
    },
    MUMBAI: {
      heading: "EXPRESS TOWERS",
      line1: "WEWORK GLOBAL OFFICES",
      line2: "EXPRESS TOWERS, MARINE DRIVE",
      line3: "NARIMAN POINT",
      line4: "MUMBAI, MAHARASHTRA, 400021",
    },
    RANCHI: {
      heading: "SANTWANA RESIDENCY",
      line1: "LEVEL 1ST, 101",
      line2: "SANTWANA RESIDENCY, BARIATU",
      line3: "RANCHI, JHARKHAND, 834009",
      line4: "",
    },
    DUBAI: {
      heading: "ONE CENTRAL DUBAI WORLD TRADE",
      line1: "LEVEL 8TH & 9TH",
      line2: "ONE CENTRAL DUBAI WORLD TRADE",
      line3: "WEWORK GLOBAL OFFICES THE OFFICES 4",
      line4: "CENTRE DUBAI, DUBAI, UAE",
    },
  };

  const handleCountryChange = (value: string) => {
    setFormData({
      selectedCountry: value,
      selectedCity: "",
    });
    setSubmitted(false);
  };

  const handleCityChange = (value: string) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      selectedCity: value,
    }));
    setSubmitted(false);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (formData.selectedCountry && formData.selectedCity) {
      setSubmitted(true);
    }
  };

  const cityOptions =
    formData.selectedCountry === "INDIA"
      ? citiesIndia
      : formData.selectedCountry === "UAE"
        ? citiesDubai
        : [];

  return (
    <div className="store-locator">
      <form className="locator-form" onSubmit={handleSubmit}>
        <h1 className="form-heading">FIND A STUDIO</h1>
        <div className="form-text">*REQUIRED FIELDS</div>

        <div className="select-location">
          <label
            htmlFor="country-select"
            className="form-text"
            style={{ fontWeight: 600 }}
          >
            * REGION / COUNTRY
          </label>
          <select
            id="country-select"
            className="form-select"
            required
            value={formData.selectedCountry}
            onChange={(e) => handleCountryChange(e.target.value)}
          >
            <option value="" disabled>
              SELECT A COUNTRY
            </option>
            {countries.map((option, index) => (
              <option key={index} value={option} className="form-option">
                {option}
              </option>
            ))}
          </select>
        </div>

        <div className="select-location">
          <label
            htmlFor="city-select"
            className="form-text"
            style={{ fontWeight: 600 }}
          >
            CITY
          </label>
          <select
            id="city-select"
            className="form-select"
            required
            disabled={!formData.selectedCountry}
            value={formData.selectedCity}
            onChange={(e) => handleCityChange(e.target.value)}
          >
            <option value="" disabled>
              {formData.selectedCountry
                ? "SELECT A CITY"
                : "SELECT A REGION FIRST"}
            </option>
            {cityOptions.map((option, index) => (
              <option key={index} value={option} className="form-option">
                {option}
              </option>
            ))}
          </select>
        </div>

        <button
          type="submit"
          className="form-button"
          disabled={!formData.selectedCountry || !formData.selectedCity}
        >
          CHOOSE
        </button>

        {submitted && formData.selectedCity && (
          <div className="address">
            <div className="form-text-address">1 STORE FOUND</div>
            <div className="address-text" style={{ fontWeight: 600 }}>
              {addresses[formData.selectedCity].heading}
            </div>
            <div className="address-text">
              {addresses[formData.selectedCity].line1}
            </div>
            <div className="address-text">
              {addresses[formData.selectedCity].line2}
            </div>
            <div className="address-text">
              {addresses[formData.selectedCity].line3}
            </div>
            <div className="address-text">
              {addresses[formData.selectedCity].line4}
            </div>
            <button
              type="button"
              className="form-button"
              style={{ marginTop: 10 }}
              onClick={(e) => {
                e.preventDefault();
                window.location.href = "tel:+919205591541";
              }}
            >
              MAKE AN APPOINTMENT
            </button>
          </div>
        )}
      </form>
      <div className="maps-image-container">
        <img
          className="maps-image"
          src={MapsImage}
          alt="Location of Ankit Atelier"
        />
      </div>
    </div>
  );
};

export default StoreLocatorForm;
